var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'card-wrapper',
    'mask-wrapper',
    'mb-0',
    _vm.is_entering_card ? 'hovered' : '',
    _vm.isHashtagged ? 'focused' : '',
    _vm.isCardSelectable ? 'draggable' : ''
  ],attrs:{"draggable":_vm.isCardSelectable},on:{"mouseenter":_vm.enterCard,"mouseleave":_vm.leaveCard,"dragstart":function($event){return _vm.handleCardDragStart($event, { name: _vm.name })},"dragend":function($event){return _vm.handleCardDragEnd($event, { name: _vm.name })}}},[_c('div',{staticClass:"mask d-none rounded cursor-grab text-nowrap overflow-hidden"}),_c('b-card',{ref:"card",staticClass:"h-100 w-100 mb-0 bordered bg-white border-info",attrs:{"no-body":"","name":_vm.name}},[_c('b-card-body',{staticClass:"p-2"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }